import { useDispatch } from 'react-redux';
import { Button, Dimmer, Header, Loader, Statistic } from 'semantic-ui-react';
import useClientTasks from '../../hooks/useClientTasks';
import { syncTimeZoneWithClient } from '../../redux/actions/clients';
import ClientTaskList from './ClientTaskList';
import SetupTasks from './SetupTasks';

const ClientTasks = ({ clientId: id }: any) => {
  const { tasks, isLoading } = useClientTasks(id);
  const dispatch = useDispatch();

  const handleSyncTimezone = () => {
    dispatch(syncTimeZoneWithClient(id));
  };
  return (
    <div>
      <Header>Scheduled Tasks</Header>
      {isLoading || !tasks ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <div>
          <Statistic.Group>
            <Statistic>
              <Statistic.Value>
                {tasks.filter((task) => task.Enabled).length}
              </Statistic.Value>
              <Statistic.Label>Active</Statistic.Label>
            </Statistic>
            <Statistic>
              <Statistic.Value>{tasks.length}</Statistic.Value>
              <Statistic.Label>Total</Statistic.Label>
            </Statistic>
          </Statistic.Group>
          <>
            {tasks.length === 0 ? (
              <SetupTasks id={id} />
            ) : (
              <Button onClick={handleSyncTimezone}>Sync Timezone</Button>
            )}
          </>
          <br />
          <ClientTaskList tasks={tasks} />
        </div>
      )}
    </div>
  );
};

export default ClientTasks;
